import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users.sms-users.add', {
        url: '/add',
        views: {
            '@company.user-directories': 'companyUserDirectoriesSaaspassUsersSmsUsersAdd'
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/sms-users/add/add-sms-user.state.js